import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardMedia,
  Divider
} from '../../Atoms'
import PropTypes from 'prop-types'
import { t as i18n } from 'ttag'
import clsx from 'clsx'

const useStyles = makeStyles({
  card: {},
  mediaContainer: {
    backgroundColor: '#fff'
  },
  media: {
    height: 140,
    margin: '0 20px',
    backgroundSize: 'contain'
  }
})

const propTypes = {
  /** Use the naming standards. */
  id: PropTypes.string.isRequired,
  /** The image inside the card */
  image: PropTypes.string.isRequired,
  /** The title of the image inside the card */
  title: PropTypes.string.isRequired,
  /** Action when open is clicked */
  onClickOpen: PropTypes.func,
  /** Action when learn is clicked */
  onClickLearn: PropTypes.func
}

const defaultProps = {
  onClickOpen: null,
  onClickLearn: null
}

/**
 * ## ApplicationCard contain content and actions about a single application.
 */

const ApplicationCard = props => {
  const classes = useStyles()
  const { id, image, title, onClickOpen, onClickLearn } = props

  return (
    <Card id={id} className={classes.card} data-cid='ApplicationCard-root'>
      <CardActionArea className={classes.mediaContainer}>
        <CardMedia
          className={clsx('app-logo', classes.media)}
          image={image}
          title={title}
        />
      </CardActionArea>
      <Divider />
      <CardActions>
        <Button
          id={id + '_open'}
          size='small'
          color='primary'
          onClick={onClickOpen}
        >
          {i18n`Open`}
        </Button>
        <Button
          id={id + '_learn'}
          size='small'
          color='inherit'
          onClick={onClickLearn}
        >
          {i18n`Learn More`}
        </Button>
      </CardActions>
    </Card>
  )
}

ApplicationCard.propTypes = propTypes
ApplicationCard.defaultProps = defaultProps

export default ApplicationCard
